module.exports = __webpack_public_path__ + "img/GAME_YUTNORI2.897a19fb.jpg";